<template>
<div style="height: 100%;width: 100%">
  <div style="height: 100%; width: 100%" :style="progressBackground"></div>
  <div style="position:absolute; top:0; left:0;height: 100%;  max-width: 100%" :style="progressStyle"></div>
  <div :style="progressPercentageStyle">{{progressPercentage}}</div>
</div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import THEME from "constants/theme";

const primaryColor = THEME.colors.light.primary;
const primaryLightColor = THEME.colors.light.primaryLight;
const textFont = THEME.typography.text;
const boldFontWeight = THEME.typography.fontWeightBold;

export default defineComponent({
  name: "AttachmentThumbnailProgress",
  props:{
    progress: {
      type: Number,
      required: true,
    },
  },
  computed:{
    progressStyle(): object {
      return {
        height: "100%",
        width: `${Math.floor(50 * this.progress)}px`,
        backgroundColor: primaryColor,
      };
    },
    progressBackground(): object{
      return {
        backgroundColor: primaryLightColor,
      };
    },
    progressPercentage(): string {
      return `${Math.floor(this.progress * 100)}%`;
    },
    progressPercentageStyle(): object {
      return {
        color: "white",
        ...textFont,
        fontWeight: boldFontWeight,
        position: "absolute",
        top: "0",
        left: "0",
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      };
    },
  }
});
</script>
